import { Typography } from '@mui/material';

import { Card } from 'src/components';
import { Flex } from 'src/components/Flex';

interface DetailsProps {
    tradingName: string;
    accountNumber: string;
    contactName: string;
    contactNumber: string;
    billingAddress: string;
    email: string;
}

const StatementBillingDetails = ({
    tradingName,
    accountNumber,
    contactNumber,
    email,
    contactName,
    billingAddress,
}: DetailsProps) => {
    return (
        <Card gap="36px">
            <Flex flexDirection="row" gap="24px">
                <Typography fontSize="20px" fontWeight="800" lineHeight="20px" color="#1d1d1b">
                    Billing Details
                </Typography>
            </Flex>
            <Flex flexDirection="row" gap="24px">
                <Flex flexDirection="column">
                    <Flex>
                        <strong>Merchant Name</strong>
                    </Flex>
                    <Flex>
                        <span>{tradingName}</span>
                    </Flex>
                </Flex>
                <Flex flexDirection="column">
                    <Flex>
                        <strong>Merchant Account Number</strong>
                    </Flex>
                    <Flex>
                        <span>{accountNumber}</span>
                    </Flex>
                </Flex>
                <Flex flexDirection="column">
                    <Flex>
                        <strong>Contact Number</strong>
                    </Flex>
                    <Flex>
                        <span>{contactNumber}</span>
                    </Flex>
                </Flex>
                <Flex flexDirection="column">
                    <Flex>
                        <strong>Email</strong>
                    </Flex>
                    <Flex>
                        <span>{email}</span>
                    </Flex>
                </Flex>
            </Flex>
            <Flex flexDirection="row" gap="24px">
                <Flex flexDirection="column" flex={1}>
                    <Flex>
                        <strong>Contact Name</strong>
                    </Flex>
                    <Flex>
                        <span>{contactName}</span>
                    </Flex>
                </Flex>
                <Flex flexDirection="column" flex={3}>
                    <Flex>
                        <strong>Billing Address</strong>
                    </Flex>
                    <Flex>
                        <span>{billingAddress}</span>
                    </Flex>
                </Flex>
            </Flex>
        </Card>
    );
};

export default StatementBillingDetails;
